import { SizableText, YStack, colors, shadowStandard } from '@my/ui'
import { Frown } from '@tamagui/lucide-icons'

interface GroupNoResultsProps {
  title: string
  description: string
}

export const GroupNoResults = ({ title, description }: GroupNoResultsProps) => {
  return (
    <YStack gap="$3.5" jc="center" ai="center" py="$6">
      <YStack br={1000} p="$2.5" jc="center" ai="center" bg="$white" {...shadowStandard}>
        <Frown color={colors.primary} width={36} height={36} />
      </YStack>
      <YStack gap="$2" ai="center" jc="center">
        <SizableText textAlign="center" size="$6" color="$overlay12" fow="600">
          {title}
        </SizableText>
        <SizableText textAlign="center" size="$4" color="$overlay10" fow="500">
          {description}
        </SizableText>
      </YStack>
    </YStack>
  )
}
